import { useEffect, useState } from "react";
import ProtRadForm from "./ProtRadForm";

const initialValues = {
    cuitResponsable: "",
    matriculaProfesional: "",
    tituloProfesional: "",
    numeroHabilitacion: "",
};

const ProtRadFormContainer = ({ open, handleClose, handleSubmit, values }) => {

    const [formInitialValues, setFormInitialValues] = useState();

    useEffect(() => {
        if (values) {
            setFormInitialValues({
                ...values,
                cuitResponsable: (values.cuitResponsable || "").replace(/[-\s]/g, "")
            });
        } else {
            setFormInitialValues(initialValues)
        }
    }, [values])


    return (
        <ProtRadForm
            open={open}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            values={formInitialValues}

        />
    )
}


export default ProtRadFormContainer; 